import styled from 'styled-components'

export const CardsWrapper = styled.div.attrs({
  className: 'wrapperCards'
})`
  max-width: 100%;
  min-width: 0;
  overflow-x: clip;
`

export const CardsGrid = styled.div.attrs({
  className: 'hold-cards'
})`
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  max-width: 100%;
  gap: var(--sl-space-2);
  width: 100%;

  overflow-x: clip;

  .card {
    margin: 0 !important;
    flex: 1 1 14.375rem !important;
    width: 0;
    min-width: 14.375rem;
    max-width: 100%;

    .media-body header {
      min-width: 0;

      > span {
        display: block;
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
`
